// Ce fichier est genere automatiquement par tools/generate-spritesheet-config.js
// Ne pas modifier manuellement
// Dossier: watcher | Taille: 256x256px | Directions: 5

import { ISpritesheetData } from 'pixi.js';

export interface ISpritesheetMetadata {
  name: string;
  metadata: ISpritesheetData;
}

export const WatcherSpritesheets: ISpritesheetMetadata[] = [
  {
    name: 'watcher-attack',
    metadata: {
      frames: {
        'watcher-attack-bottom-0': {
          frame: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-attack-bottom-1': {
          frame: {
            x: 256,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-attack-bottom-2': {
          frame: {
            x: 512,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-attack-bottom-3': {
          frame: {
            x: 768,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-attack-bottom-4': {
          frame: {
            x: 1024,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-attack-bottom-5': {
          frame: {
            x: 1280,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-attack-bottom-6': {
          frame: {
            x: 1536,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-attack-bottom-7': {
          frame: {
            x: 1792,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-attack-bottom-8': {
          frame: {
            x: 2048,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-attack-bottom-9': {
          frame: {
            x: 2304,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-attack-bottom-10': {
          frame: {
            x: 2560,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-attack-bottom-11': {
          frame: {
            x: 2816,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-attack-bottom-12': {
          frame: {
            x: 3072,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-attack-bottom-13': {
          frame: {
            x: 3328,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-attack-bottom-14': {
          frame: {
            x: 3584,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-attack-bottom-15': {
          frame: {
            x: 3840,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-attack-bottom-left-0': {
          frame: {
            x: 0,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-attack-bottom-left-1': {
          frame: {
            x: 256,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-attack-bottom-left-2': {
          frame: {
            x: 512,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-attack-bottom-left-3': {
          frame: {
            x: 768,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-attack-bottom-left-4': {
          frame: {
            x: 1024,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-attack-bottom-left-5': {
          frame: {
            x: 1280,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-attack-bottom-left-6': {
          frame: {
            x: 1536,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-attack-bottom-left-7': {
          frame: {
            x: 1792,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-attack-bottom-left-8': {
          frame: {
            x: 2048,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-attack-bottom-left-9': {
          frame: {
            x: 2304,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-attack-bottom-left-10': {
          frame: {
            x: 2560,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-attack-bottom-left-11': {
          frame: {
            x: 2816,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-attack-bottom-left-12': {
          frame: {
            x: 3072,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-attack-bottom-left-13': {
          frame: {
            x: 3328,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-attack-bottom-left-14': {
          frame: {
            x: 3584,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-attack-bottom-left-15': {
          frame: {
            x: 3840,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-attack-left-0': {
          frame: {
            x: 0,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-attack-left-1': {
          frame: {
            x: 256,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-attack-left-2': {
          frame: {
            x: 512,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-attack-left-3': {
          frame: {
            x: 768,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-attack-left-4': {
          frame: {
            x: 1024,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-attack-left-5': {
          frame: {
            x: 1280,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-attack-left-6': {
          frame: {
            x: 1536,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-attack-left-7': {
          frame: {
            x: 1792,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-attack-left-8': {
          frame: {
            x: 2048,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-attack-left-9': {
          frame: {
            x: 2304,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-attack-left-10': {
          frame: {
            x: 2560,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-attack-left-11': {
          frame: {
            x: 2816,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-attack-left-12': {
          frame: {
            x: 3072,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-attack-left-13': {
          frame: {
            x: 3328,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-attack-left-14': {
          frame: {
            x: 3584,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-attack-left-15': {
          frame: {
            x: 3840,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-attack-top-left-0': {
          frame: {
            x: 0,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-attack-top-left-1': {
          frame: {
            x: 256,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-attack-top-left-2': {
          frame: {
            x: 512,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-attack-top-left-3': {
          frame: {
            x: 768,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-attack-top-left-4': {
          frame: {
            x: 1024,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-attack-top-left-5': {
          frame: {
            x: 1280,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-attack-top-left-6': {
          frame: {
            x: 1536,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-attack-top-left-7': {
          frame: {
            x: 1792,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-attack-top-left-8': {
          frame: {
            x: 2048,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-attack-top-left-9': {
          frame: {
            x: 2304,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-attack-top-left-10': {
          frame: {
            x: 2560,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-attack-top-left-11': {
          frame: {
            x: 2816,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-attack-top-left-12': {
          frame: {
            x: 3072,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-attack-top-left-13': {
          frame: {
            x: 3328,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-attack-top-left-14': {
          frame: {
            x: 3584,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-attack-top-left-15': {
          frame: {
            x: 3840,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-attack-top-0': {
          frame: {
            x: 0,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-attack-top-1': {
          frame: {
            x: 256,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-attack-top-2': {
          frame: {
            x: 512,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-attack-top-3': {
          frame: {
            x: 768,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-attack-top-4': {
          frame: {
            x: 1024,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-attack-top-5': {
          frame: {
            x: 1280,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-attack-top-6': {
          frame: {
            x: 1536,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-attack-top-7': {
          frame: {
            x: 1792,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-attack-top-8': {
          frame: {
            x: 2048,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-attack-top-9': {
          frame: {
            x: 2304,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-attack-top-10': {
          frame: {
            x: 2560,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-attack-top-11': {
          frame: {
            x: 2816,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-attack-top-12': {
          frame: {
            x: 3072,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-attack-top-13': {
          frame: {
            x: 3328,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-attack-top-14': {
          frame: {
            x: 3584,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-attack-top-15': {
          frame: {
            x: 3840,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
      },
      meta: {
        image: '/sprites/entities/watcher/attack.png',
        size: {
          w: 4096,
          h: 1280,
        },
        scale: '1',
      },
      animations: {
        'watcher-attack-bottom': [
          'watcher-attack-bottom-0',
          'watcher-attack-bottom-1',
          'watcher-attack-bottom-2',
          'watcher-attack-bottom-3',
          'watcher-attack-bottom-4',
          'watcher-attack-bottom-5',
          'watcher-attack-bottom-6',
          'watcher-attack-bottom-7',
          'watcher-attack-bottom-8',
          'watcher-attack-bottom-9',
          'watcher-attack-bottom-10',
          'watcher-attack-bottom-11',
          'watcher-attack-bottom-12',
          'watcher-attack-bottom-13',
          'watcher-attack-bottom-14',
          'watcher-attack-bottom-15',
        ],
        'watcher-attack-bottom-left': [
          'watcher-attack-bottom-left-0',
          'watcher-attack-bottom-left-1',
          'watcher-attack-bottom-left-2',
          'watcher-attack-bottom-left-3',
          'watcher-attack-bottom-left-4',
          'watcher-attack-bottom-left-5',
          'watcher-attack-bottom-left-6',
          'watcher-attack-bottom-left-7',
          'watcher-attack-bottom-left-8',
          'watcher-attack-bottom-left-9',
          'watcher-attack-bottom-left-10',
          'watcher-attack-bottom-left-11',
          'watcher-attack-bottom-left-12',
          'watcher-attack-bottom-left-13',
          'watcher-attack-bottom-left-14',
          'watcher-attack-bottom-left-15',
        ],
        'watcher-attack-left': [
          'watcher-attack-left-0',
          'watcher-attack-left-1',
          'watcher-attack-left-2',
          'watcher-attack-left-3',
          'watcher-attack-left-4',
          'watcher-attack-left-5',
          'watcher-attack-left-6',
          'watcher-attack-left-7',
          'watcher-attack-left-8',
          'watcher-attack-left-9',
          'watcher-attack-left-10',
          'watcher-attack-left-11',
          'watcher-attack-left-12',
          'watcher-attack-left-13',
          'watcher-attack-left-14',
          'watcher-attack-left-15',
        ],
        'watcher-attack-top-left': [
          'watcher-attack-top-left-0',
          'watcher-attack-top-left-1',
          'watcher-attack-top-left-2',
          'watcher-attack-top-left-3',
          'watcher-attack-top-left-4',
          'watcher-attack-top-left-5',
          'watcher-attack-top-left-6',
          'watcher-attack-top-left-7',
          'watcher-attack-top-left-8',
          'watcher-attack-top-left-9',
          'watcher-attack-top-left-10',
          'watcher-attack-top-left-11',
          'watcher-attack-top-left-12',
          'watcher-attack-top-left-13',
          'watcher-attack-top-left-14',
          'watcher-attack-top-left-15',
        ],
        'watcher-attack-top': [
          'watcher-attack-top-0',
          'watcher-attack-top-1',
          'watcher-attack-top-2',
          'watcher-attack-top-3',
          'watcher-attack-top-4',
          'watcher-attack-top-5',
          'watcher-attack-top-6',
          'watcher-attack-top-7',
          'watcher-attack-top-8',
          'watcher-attack-top-9',
          'watcher-attack-top-10',
          'watcher-attack-top-11',
          'watcher-attack-top-12',
          'watcher-attack-top-13',
          'watcher-attack-top-14',
          'watcher-attack-top-15',
        ],
      },
    },
  },
  {
    name: 'watcher-death',
    metadata: {
      frames: {
        'watcher-death-bottom-0': {
          frame: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-death-bottom-1': {
          frame: {
            x: 256,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-death-bottom-2': {
          frame: {
            x: 512,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-death-bottom-3': {
          frame: {
            x: 768,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-death-bottom-4': {
          frame: {
            x: 1024,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-death-bottom-5': {
          frame: {
            x: 1280,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-death-bottom-6': {
          frame: {
            x: 1536,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-death-bottom-7': {
          frame: {
            x: 1792,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-death-bottom-8': {
          frame: {
            x: 2048,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-death-bottom-9': {
          frame: {
            x: 2304,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-death-bottom-10': {
          frame: {
            x: 2560,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-death-bottom-11': {
          frame: {
            x: 2816,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-death-bottom-12': {
          frame: {
            x: 3072,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-death-bottom-13': {
          frame: {
            x: 3328,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-death-bottom-14': {
          frame: {
            x: 3584,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-death-bottom-15': {
          frame: {
            x: 3840,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-death-bottom-16': {
          frame: {
            x: 4096,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-death-bottom-17': {
          frame: {
            x: 4352,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-death-bottom-18': {
          frame: {
            x: 4608,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-death-bottom-19': {
          frame: {
            x: 4864,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-death-bottom-20': {
          frame: {
            x: 5120,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-death-bottom-21': {
          frame: {
            x: 5376,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-death-bottom-22': {
          frame: {
            x: 5632,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-death-bottom-23': {
          frame: {
            x: 5888,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-death-bottom-left-0': {
          frame: {
            x: 0,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-death-bottom-left-1': {
          frame: {
            x: 256,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-death-bottom-left-2': {
          frame: {
            x: 512,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-death-bottom-left-3': {
          frame: {
            x: 768,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-death-bottom-left-4': {
          frame: {
            x: 1024,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-death-bottom-left-5': {
          frame: {
            x: 1280,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-death-bottom-left-6': {
          frame: {
            x: 1536,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-death-bottom-left-7': {
          frame: {
            x: 1792,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-death-bottom-left-8': {
          frame: {
            x: 2048,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-death-bottom-left-9': {
          frame: {
            x: 2304,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-death-bottom-left-10': {
          frame: {
            x: 2560,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-death-bottom-left-11': {
          frame: {
            x: 2816,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-death-bottom-left-12': {
          frame: {
            x: 3072,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-death-bottom-left-13': {
          frame: {
            x: 3328,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-death-bottom-left-14': {
          frame: {
            x: 3584,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-death-bottom-left-15': {
          frame: {
            x: 3840,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-death-bottom-left-16': {
          frame: {
            x: 4096,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-death-bottom-left-17': {
          frame: {
            x: 4352,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-death-bottom-left-18': {
          frame: {
            x: 4608,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-death-bottom-left-19': {
          frame: {
            x: 4864,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-death-bottom-left-20': {
          frame: {
            x: 5120,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-death-bottom-left-21': {
          frame: {
            x: 5376,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-death-bottom-left-22': {
          frame: {
            x: 5632,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-death-bottom-left-23': {
          frame: {
            x: 5888,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-death-left-0': {
          frame: {
            x: 0,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-death-left-1': {
          frame: {
            x: 256,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-death-left-2': {
          frame: {
            x: 512,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-death-left-3': {
          frame: {
            x: 768,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-death-left-4': {
          frame: {
            x: 1024,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-death-left-5': {
          frame: {
            x: 1280,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-death-left-6': {
          frame: {
            x: 1536,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-death-left-7': {
          frame: {
            x: 1792,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-death-left-8': {
          frame: {
            x: 2048,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-death-left-9': {
          frame: {
            x: 2304,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-death-left-10': {
          frame: {
            x: 2560,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-death-left-11': {
          frame: {
            x: 2816,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-death-left-12': {
          frame: {
            x: 3072,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-death-left-13': {
          frame: {
            x: 3328,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-death-left-14': {
          frame: {
            x: 3584,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-death-left-15': {
          frame: {
            x: 3840,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-death-left-16': {
          frame: {
            x: 4096,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-death-left-17': {
          frame: {
            x: 4352,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-death-left-18': {
          frame: {
            x: 4608,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-death-left-19': {
          frame: {
            x: 4864,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-death-left-20': {
          frame: {
            x: 5120,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-death-left-21': {
          frame: {
            x: 5376,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-death-left-22': {
          frame: {
            x: 5632,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-death-left-23': {
          frame: {
            x: 5888,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-death-top-left-0': {
          frame: {
            x: 0,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-death-top-left-1': {
          frame: {
            x: 256,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-death-top-left-2': {
          frame: {
            x: 512,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-death-top-left-3': {
          frame: {
            x: 768,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-death-top-left-4': {
          frame: {
            x: 1024,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-death-top-left-5': {
          frame: {
            x: 1280,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-death-top-left-6': {
          frame: {
            x: 1536,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-death-top-left-7': {
          frame: {
            x: 1792,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-death-top-left-8': {
          frame: {
            x: 2048,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-death-top-left-9': {
          frame: {
            x: 2304,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-death-top-left-10': {
          frame: {
            x: 2560,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-death-top-left-11': {
          frame: {
            x: 2816,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-death-top-left-12': {
          frame: {
            x: 3072,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-death-top-left-13': {
          frame: {
            x: 3328,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-death-top-left-14': {
          frame: {
            x: 3584,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-death-top-left-15': {
          frame: {
            x: 3840,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-death-top-left-16': {
          frame: {
            x: 4096,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-death-top-left-17': {
          frame: {
            x: 4352,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-death-top-left-18': {
          frame: {
            x: 4608,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-death-top-left-19': {
          frame: {
            x: 4864,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-death-top-left-20': {
          frame: {
            x: 5120,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-death-top-left-21': {
          frame: {
            x: 5376,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-death-top-left-22': {
          frame: {
            x: 5632,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-death-top-left-23': {
          frame: {
            x: 5888,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-death-top-0': {
          frame: {
            x: 0,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-death-top-1': {
          frame: {
            x: 256,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-death-top-2': {
          frame: {
            x: 512,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-death-top-3': {
          frame: {
            x: 768,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-death-top-4': {
          frame: {
            x: 1024,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-death-top-5': {
          frame: {
            x: 1280,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-death-top-6': {
          frame: {
            x: 1536,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-death-top-7': {
          frame: {
            x: 1792,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-death-top-8': {
          frame: {
            x: 2048,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-death-top-9': {
          frame: {
            x: 2304,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-death-top-10': {
          frame: {
            x: 2560,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-death-top-11': {
          frame: {
            x: 2816,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-death-top-12': {
          frame: {
            x: 3072,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-death-top-13': {
          frame: {
            x: 3328,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-death-top-14': {
          frame: {
            x: 3584,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-death-top-15': {
          frame: {
            x: 3840,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-death-top-16': {
          frame: {
            x: 4096,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-death-top-17': {
          frame: {
            x: 4352,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-death-top-18': {
          frame: {
            x: 4608,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-death-top-19': {
          frame: {
            x: 4864,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-death-top-20': {
          frame: {
            x: 5120,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-death-top-21': {
          frame: {
            x: 5376,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-death-top-22': {
          frame: {
            x: 5632,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-death-top-23': {
          frame: {
            x: 5888,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
      },
      meta: {
        image: '/sprites/entities/watcher/death.png',
        size: {
          w: 6144,
          h: 1280,
        },
        scale: '1',
      },
      animations: {
        'watcher-death-bottom': [
          'watcher-death-bottom-0',
          'watcher-death-bottom-1',
          'watcher-death-bottom-2',
          'watcher-death-bottom-3',
          'watcher-death-bottom-4',
          'watcher-death-bottom-5',
          'watcher-death-bottom-6',
          'watcher-death-bottom-7',
          'watcher-death-bottom-8',
          'watcher-death-bottom-9',
          'watcher-death-bottom-10',
          'watcher-death-bottom-11',
          'watcher-death-bottom-12',
          'watcher-death-bottom-13',
          'watcher-death-bottom-14',
          'watcher-death-bottom-15',
          'watcher-death-bottom-16',
          'watcher-death-bottom-17',
          'watcher-death-bottom-18',
          'watcher-death-bottom-19',
          'watcher-death-bottom-20',
          'watcher-death-bottom-21',
          'watcher-death-bottom-22',
          'watcher-death-bottom-23',
        ],
        'watcher-death-bottom-left': [
          'watcher-death-bottom-left-0',
          'watcher-death-bottom-left-1',
          'watcher-death-bottom-left-2',
          'watcher-death-bottom-left-3',
          'watcher-death-bottom-left-4',
          'watcher-death-bottom-left-5',
          'watcher-death-bottom-left-6',
          'watcher-death-bottom-left-7',
          'watcher-death-bottom-left-8',
          'watcher-death-bottom-left-9',
          'watcher-death-bottom-left-10',
          'watcher-death-bottom-left-11',
          'watcher-death-bottom-left-12',
          'watcher-death-bottom-left-13',
          'watcher-death-bottom-left-14',
          'watcher-death-bottom-left-15',
          'watcher-death-bottom-left-16',
          'watcher-death-bottom-left-17',
          'watcher-death-bottom-left-18',
          'watcher-death-bottom-left-19',
          'watcher-death-bottom-left-20',
          'watcher-death-bottom-left-21',
          'watcher-death-bottom-left-22',
          'watcher-death-bottom-left-23',
        ],
        'watcher-death-left': [
          'watcher-death-left-0',
          'watcher-death-left-1',
          'watcher-death-left-2',
          'watcher-death-left-3',
          'watcher-death-left-4',
          'watcher-death-left-5',
          'watcher-death-left-6',
          'watcher-death-left-7',
          'watcher-death-left-8',
          'watcher-death-left-9',
          'watcher-death-left-10',
          'watcher-death-left-11',
          'watcher-death-left-12',
          'watcher-death-left-13',
          'watcher-death-left-14',
          'watcher-death-left-15',
          'watcher-death-left-16',
          'watcher-death-left-17',
          'watcher-death-left-18',
          'watcher-death-left-19',
          'watcher-death-left-20',
          'watcher-death-left-21',
          'watcher-death-left-22',
          'watcher-death-left-23',
        ],
        'watcher-death-top-left': [
          'watcher-death-top-left-0',
          'watcher-death-top-left-1',
          'watcher-death-top-left-2',
          'watcher-death-top-left-3',
          'watcher-death-top-left-4',
          'watcher-death-top-left-5',
          'watcher-death-top-left-6',
          'watcher-death-top-left-7',
          'watcher-death-top-left-8',
          'watcher-death-top-left-9',
          'watcher-death-top-left-10',
          'watcher-death-top-left-11',
          'watcher-death-top-left-12',
          'watcher-death-top-left-13',
          'watcher-death-top-left-14',
          'watcher-death-top-left-15',
          'watcher-death-top-left-16',
          'watcher-death-top-left-17',
          'watcher-death-top-left-18',
          'watcher-death-top-left-19',
          'watcher-death-top-left-20',
          'watcher-death-top-left-21',
          'watcher-death-top-left-22',
          'watcher-death-top-left-23',
        ],
        'watcher-death-top': [
          'watcher-death-top-0',
          'watcher-death-top-1',
          'watcher-death-top-2',
          'watcher-death-top-3',
          'watcher-death-top-4',
          'watcher-death-top-5',
          'watcher-death-top-6',
          'watcher-death-top-7',
          'watcher-death-top-8',
          'watcher-death-top-9',
          'watcher-death-top-10',
          'watcher-death-top-11',
          'watcher-death-top-12',
          'watcher-death-top-13',
          'watcher-death-top-14',
          'watcher-death-top-15',
          'watcher-death-top-16',
          'watcher-death-top-17',
          'watcher-death-top-18',
          'watcher-death-top-19',
          'watcher-death-top-20',
          'watcher-death-top-21',
          'watcher-death-top-22',
          'watcher-death-top-23',
        ],
      },
    },
  },
  {
    name: 'watcher-idle',
    metadata: {
      frames: {
        'watcher-idle-bottom-0': {
          frame: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-idle-bottom-1': {
          frame: {
            x: 256,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-idle-bottom-2': {
          frame: {
            x: 512,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-idle-bottom-3': {
          frame: {
            x: 768,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-idle-bottom-4': {
          frame: {
            x: 1024,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-idle-bottom-5': {
          frame: {
            x: 1280,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-idle-bottom-6': {
          frame: {
            x: 1536,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-idle-bottom-7': {
          frame: {
            x: 1792,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-idle-bottom-8': {
          frame: {
            x: 2048,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-idle-bottom-9': {
          frame: {
            x: 2304,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-idle-bottom-10': {
          frame: {
            x: 2560,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-idle-bottom-11': {
          frame: {
            x: 2816,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-idle-bottom-12': {
          frame: {
            x: 3072,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-idle-bottom-13': {
          frame: {
            x: 3328,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-idle-bottom-14': {
          frame: {
            x: 3584,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-idle-bottom-15': {
          frame: {
            x: 3840,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-idle-bottom-left-0': {
          frame: {
            x: 0,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-idle-bottom-left-1': {
          frame: {
            x: 256,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-idle-bottom-left-2': {
          frame: {
            x: 512,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-idle-bottom-left-3': {
          frame: {
            x: 768,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-idle-bottom-left-4': {
          frame: {
            x: 1024,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-idle-bottom-left-5': {
          frame: {
            x: 1280,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-idle-bottom-left-6': {
          frame: {
            x: 1536,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-idle-bottom-left-7': {
          frame: {
            x: 1792,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-idle-bottom-left-8': {
          frame: {
            x: 2048,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-idle-bottom-left-9': {
          frame: {
            x: 2304,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-idle-bottom-left-10': {
          frame: {
            x: 2560,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-idle-bottom-left-11': {
          frame: {
            x: 2816,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-idle-bottom-left-12': {
          frame: {
            x: 3072,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-idle-bottom-left-13': {
          frame: {
            x: 3328,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-idle-bottom-left-14': {
          frame: {
            x: 3584,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-idle-bottom-left-15': {
          frame: {
            x: 3840,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-idle-left-0': {
          frame: {
            x: 0,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-idle-left-1': {
          frame: {
            x: 256,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-idle-left-2': {
          frame: {
            x: 512,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-idle-left-3': {
          frame: {
            x: 768,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-idle-left-4': {
          frame: {
            x: 1024,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-idle-left-5': {
          frame: {
            x: 1280,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-idle-left-6': {
          frame: {
            x: 1536,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-idle-left-7': {
          frame: {
            x: 1792,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-idle-left-8': {
          frame: {
            x: 2048,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-idle-left-9': {
          frame: {
            x: 2304,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-idle-left-10': {
          frame: {
            x: 2560,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-idle-left-11': {
          frame: {
            x: 2816,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-idle-left-12': {
          frame: {
            x: 3072,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-idle-left-13': {
          frame: {
            x: 3328,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-idle-left-14': {
          frame: {
            x: 3584,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-idle-left-15': {
          frame: {
            x: 3840,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-idle-top-left-0': {
          frame: {
            x: 0,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-idle-top-left-1': {
          frame: {
            x: 256,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-idle-top-left-2': {
          frame: {
            x: 512,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-idle-top-left-3': {
          frame: {
            x: 768,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-idle-top-left-4': {
          frame: {
            x: 1024,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-idle-top-left-5': {
          frame: {
            x: 1280,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-idle-top-left-6': {
          frame: {
            x: 1536,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-idle-top-left-7': {
          frame: {
            x: 1792,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-idle-top-left-8': {
          frame: {
            x: 2048,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-idle-top-left-9': {
          frame: {
            x: 2304,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-idle-top-left-10': {
          frame: {
            x: 2560,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-idle-top-left-11': {
          frame: {
            x: 2816,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-idle-top-left-12': {
          frame: {
            x: 3072,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-idle-top-left-13': {
          frame: {
            x: 3328,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-idle-top-left-14': {
          frame: {
            x: 3584,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-idle-top-left-15': {
          frame: {
            x: 3840,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-idle-top-0': {
          frame: {
            x: 0,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-idle-top-1': {
          frame: {
            x: 256,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-idle-top-2': {
          frame: {
            x: 512,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-idle-top-3': {
          frame: {
            x: 768,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-idle-top-4': {
          frame: {
            x: 1024,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-idle-top-5': {
          frame: {
            x: 1280,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-idle-top-6': {
          frame: {
            x: 1536,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-idle-top-7': {
          frame: {
            x: 1792,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-idle-top-8': {
          frame: {
            x: 2048,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-idle-top-9': {
          frame: {
            x: 2304,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-idle-top-10': {
          frame: {
            x: 2560,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-idle-top-11': {
          frame: {
            x: 2816,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-idle-top-12': {
          frame: {
            x: 3072,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-idle-top-13': {
          frame: {
            x: 3328,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-idle-top-14': {
          frame: {
            x: 3584,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-idle-top-15': {
          frame: {
            x: 3840,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
      },
      meta: {
        image: '/sprites/entities/watcher/idle.png',
        size: {
          w: 4096,
          h: 1280,
        },
        scale: '1',
      },
      animations: {
        'watcher-idle-bottom': [
          'watcher-idle-bottom-0',
          'watcher-idle-bottom-1',
          'watcher-idle-bottom-2',
          'watcher-idle-bottom-3',
          'watcher-idle-bottom-4',
          'watcher-idle-bottom-5',
          'watcher-idle-bottom-6',
          'watcher-idle-bottom-7',
          'watcher-idle-bottom-8',
          'watcher-idle-bottom-9',
          'watcher-idle-bottom-10',
          'watcher-idle-bottom-11',
          'watcher-idle-bottom-12',
          'watcher-idle-bottom-13',
          'watcher-idle-bottom-14',
          'watcher-idle-bottom-15',
        ],
        'watcher-idle-bottom-left': [
          'watcher-idle-bottom-left-0',
          'watcher-idle-bottom-left-1',
          'watcher-idle-bottom-left-2',
          'watcher-idle-bottom-left-3',
          'watcher-idle-bottom-left-4',
          'watcher-idle-bottom-left-5',
          'watcher-idle-bottom-left-6',
          'watcher-idle-bottom-left-7',
          'watcher-idle-bottom-left-8',
          'watcher-idle-bottom-left-9',
          'watcher-idle-bottom-left-10',
          'watcher-idle-bottom-left-11',
          'watcher-idle-bottom-left-12',
          'watcher-idle-bottom-left-13',
          'watcher-idle-bottom-left-14',
          'watcher-idle-bottom-left-15',
        ],
        'watcher-idle-left': [
          'watcher-idle-left-0',
          'watcher-idle-left-1',
          'watcher-idle-left-2',
          'watcher-idle-left-3',
          'watcher-idle-left-4',
          'watcher-idle-left-5',
          'watcher-idle-left-6',
          'watcher-idle-left-7',
          'watcher-idle-left-8',
          'watcher-idle-left-9',
          'watcher-idle-left-10',
          'watcher-idle-left-11',
          'watcher-idle-left-12',
          'watcher-idle-left-13',
          'watcher-idle-left-14',
          'watcher-idle-left-15',
        ],
        'watcher-idle-top-left': [
          'watcher-idle-top-left-0',
          'watcher-idle-top-left-1',
          'watcher-idle-top-left-2',
          'watcher-idle-top-left-3',
          'watcher-idle-top-left-4',
          'watcher-idle-top-left-5',
          'watcher-idle-top-left-6',
          'watcher-idle-top-left-7',
          'watcher-idle-top-left-8',
          'watcher-idle-top-left-9',
          'watcher-idle-top-left-10',
          'watcher-idle-top-left-11',
          'watcher-idle-top-left-12',
          'watcher-idle-top-left-13',
          'watcher-idle-top-left-14',
          'watcher-idle-top-left-15',
        ],
        'watcher-idle-top': [
          'watcher-idle-top-0',
          'watcher-idle-top-1',
          'watcher-idle-top-2',
          'watcher-idle-top-3',
          'watcher-idle-top-4',
          'watcher-idle-top-5',
          'watcher-idle-top-6',
          'watcher-idle-top-7',
          'watcher-idle-top-8',
          'watcher-idle-top-9',
          'watcher-idle-top-10',
          'watcher-idle-top-11',
          'watcher-idle-top-12',
          'watcher-idle-top-13',
          'watcher-idle-top-14',
          'watcher-idle-top-15',
        ],
      },
    },
  },
  {
    name: 'watcher-walk',
    metadata: {
      frames: {
        'watcher-walk-bottom-0': {
          frame: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-walk-bottom-1': {
          frame: {
            x: 256,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-walk-bottom-2': {
          frame: {
            x: 512,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-walk-bottom-3': {
          frame: {
            x: 768,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-walk-bottom-4': {
          frame: {
            x: 1024,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-walk-bottom-5': {
          frame: {
            x: 1280,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-walk-bottom-6': {
          frame: {
            x: 1536,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-walk-bottom-7': {
          frame: {
            x: 1792,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-walk-bottom-8': {
          frame: {
            x: 2048,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-walk-bottom-9': {
          frame: {
            x: 2304,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-walk-bottom-10': {
          frame: {
            x: 2560,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-walk-bottom-11': {
          frame: {
            x: 2816,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-walk-bottom-12': {
          frame: {
            x: 3072,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-walk-bottom-13': {
          frame: {
            x: 3328,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-walk-bottom-14': {
          frame: {
            x: 3584,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-walk-bottom-15': {
          frame: {
            x: 3840,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-walk-bottom-16': {
          frame: {
            x: 4096,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-walk-bottom-17': {
          frame: {
            x: 4352,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-walk-bottom-18': {
          frame: {
            x: 4608,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-walk-bottom-19': {
          frame: {
            x: 4864,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-walk-bottom-left-0': {
          frame: {
            x: 0,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-walk-bottom-left-1': {
          frame: {
            x: 256,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-walk-bottom-left-2': {
          frame: {
            x: 512,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-walk-bottom-left-3': {
          frame: {
            x: 768,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-walk-bottom-left-4': {
          frame: {
            x: 1024,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-walk-bottom-left-5': {
          frame: {
            x: 1280,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-walk-bottom-left-6': {
          frame: {
            x: 1536,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-walk-bottom-left-7': {
          frame: {
            x: 1792,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-walk-bottom-left-8': {
          frame: {
            x: 2048,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-walk-bottom-left-9': {
          frame: {
            x: 2304,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-walk-bottom-left-10': {
          frame: {
            x: 2560,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-walk-bottom-left-11': {
          frame: {
            x: 2816,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-walk-bottom-left-12': {
          frame: {
            x: 3072,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-walk-bottom-left-13': {
          frame: {
            x: 3328,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-walk-bottom-left-14': {
          frame: {
            x: 3584,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-walk-bottom-left-15': {
          frame: {
            x: 3840,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-walk-bottom-left-16': {
          frame: {
            x: 4096,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-walk-bottom-left-17': {
          frame: {
            x: 4352,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-walk-bottom-left-18': {
          frame: {
            x: 4608,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-walk-bottom-left-19': {
          frame: {
            x: 4864,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-walk-left-0': {
          frame: {
            x: 0,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-walk-left-1': {
          frame: {
            x: 256,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-walk-left-2': {
          frame: {
            x: 512,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-walk-left-3': {
          frame: {
            x: 768,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-walk-left-4': {
          frame: {
            x: 1024,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-walk-left-5': {
          frame: {
            x: 1280,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-walk-left-6': {
          frame: {
            x: 1536,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-walk-left-7': {
          frame: {
            x: 1792,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-walk-left-8': {
          frame: {
            x: 2048,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-walk-left-9': {
          frame: {
            x: 2304,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-walk-left-10': {
          frame: {
            x: 2560,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-walk-left-11': {
          frame: {
            x: 2816,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-walk-left-12': {
          frame: {
            x: 3072,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-walk-left-13': {
          frame: {
            x: 3328,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-walk-left-14': {
          frame: {
            x: 3584,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-walk-left-15': {
          frame: {
            x: 3840,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-walk-left-16': {
          frame: {
            x: 4096,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-walk-left-17': {
          frame: {
            x: 4352,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-walk-left-18': {
          frame: {
            x: 4608,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-walk-left-19': {
          frame: {
            x: 4864,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-walk-top-left-0': {
          frame: {
            x: 0,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-walk-top-left-1': {
          frame: {
            x: 256,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-walk-top-left-2': {
          frame: {
            x: 512,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-walk-top-left-3': {
          frame: {
            x: 768,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-walk-top-left-4': {
          frame: {
            x: 1024,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-walk-top-left-5': {
          frame: {
            x: 1280,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-walk-top-left-6': {
          frame: {
            x: 1536,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-walk-top-left-7': {
          frame: {
            x: 1792,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-walk-top-left-8': {
          frame: {
            x: 2048,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-walk-top-left-9': {
          frame: {
            x: 2304,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-walk-top-left-10': {
          frame: {
            x: 2560,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-walk-top-left-11': {
          frame: {
            x: 2816,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-walk-top-left-12': {
          frame: {
            x: 3072,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-walk-top-left-13': {
          frame: {
            x: 3328,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-walk-top-left-14': {
          frame: {
            x: 3584,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-walk-top-left-15': {
          frame: {
            x: 3840,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-walk-top-left-16': {
          frame: {
            x: 4096,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-walk-top-left-17': {
          frame: {
            x: 4352,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-walk-top-left-18': {
          frame: {
            x: 4608,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-walk-top-left-19': {
          frame: {
            x: 4864,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-walk-top-0': {
          frame: {
            x: 0,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-walk-top-1': {
          frame: {
            x: 256,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-walk-top-2': {
          frame: {
            x: 512,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-walk-top-3': {
          frame: {
            x: 768,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-walk-top-4': {
          frame: {
            x: 1024,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-walk-top-5': {
          frame: {
            x: 1280,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-walk-top-6': {
          frame: {
            x: 1536,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-walk-top-7': {
          frame: {
            x: 1792,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-walk-top-8': {
          frame: {
            x: 2048,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-walk-top-9': {
          frame: {
            x: 2304,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-walk-top-10': {
          frame: {
            x: 2560,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-walk-top-11': {
          frame: {
            x: 2816,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-walk-top-12': {
          frame: {
            x: 3072,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-walk-top-13': {
          frame: {
            x: 3328,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-walk-top-14': {
          frame: {
            x: 3584,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-walk-top-15': {
          frame: {
            x: 3840,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-walk-top-16': {
          frame: {
            x: 4096,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-walk-top-17': {
          frame: {
            x: 4352,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-walk-top-18': {
          frame: {
            x: 4608,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'watcher-walk-top-19': {
          frame: {
            x: 4864,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
      },
      meta: {
        image: '/sprites/entities/watcher/walk.png',
        size: {
          w: 5120,
          h: 1280,
        },
        scale: '1',
      },
      animations: {
        'watcher-walk-bottom': [
          'watcher-walk-bottom-0',
          'watcher-walk-bottom-1',
          'watcher-walk-bottom-2',
          'watcher-walk-bottom-3',
          'watcher-walk-bottom-4',
          'watcher-walk-bottom-5',
          'watcher-walk-bottom-6',
          'watcher-walk-bottom-7',
          'watcher-walk-bottom-8',
          'watcher-walk-bottom-9',
          'watcher-walk-bottom-10',
          'watcher-walk-bottom-11',
          'watcher-walk-bottom-12',
          'watcher-walk-bottom-13',
          'watcher-walk-bottom-14',
          'watcher-walk-bottom-15',
          'watcher-walk-bottom-16',
          'watcher-walk-bottom-17',
          'watcher-walk-bottom-18',
          'watcher-walk-bottom-19',
        ],
        'watcher-walk-bottom-left': [
          'watcher-walk-bottom-left-0',
          'watcher-walk-bottom-left-1',
          'watcher-walk-bottom-left-2',
          'watcher-walk-bottom-left-3',
          'watcher-walk-bottom-left-4',
          'watcher-walk-bottom-left-5',
          'watcher-walk-bottom-left-6',
          'watcher-walk-bottom-left-7',
          'watcher-walk-bottom-left-8',
          'watcher-walk-bottom-left-9',
          'watcher-walk-bottom-left-10',
          'watcher-walk-bottom-left-11',
          'watcher-walk-bottom-left-12',
          'watcher-walk-bottom-left-13',
          'watcher-walk-bottom-left-14',
          'watcher-walk-bottom-left-15',
          'watcher-walk-bottom-left-16',
          'watcher-walk-bottom-left-17',
          'watcher-walk-bottom-left-18',
          'watcher-walk-bottom-left-19',
        ],
        'watcher-walk-left': [
          'watcher-walk-left-0',
          'watcher-walk-left-1',
          'watcher-walk-left-2',
          'watcher-walk-left-3',
          'watcher-walk-left-4',
          'watcher-walk-left-5',
          'watcher-walk-left-6',
          'watcher-walk-left-7',
          'watcher-walk-left-8',
          'watcher-walk-left-9',
          'watcher-walk-left-10',
          'watcher-walk-left-11',
          'watcher-walk-left-12',
          'watcher-walk-left-13',
          'watcher-walk-left-14',
          'watcher-walk-left-15',
          'watcher-walk-left-16',
          'watcher-walk-left-17',
          'watcher-walk-left-18',
          'watcher-walk-left-19',
        ],
        'watcher-walk-top-left': [
          'watcher-walk-top-left-0',
          'watcher-walk-top-left-1',
          'watcher-walk-top-left-2',
          'watcher-walk-top-left-3',
          'watcher-walk-top-left-4',
          'watcher-walk-top-left-5',
          'watcher-walk-top-left-6',
          'watcher-walk-top-left-7',
          'watcher-walk-top-left-8',
          'watcher-walk-top-left-9',
          'watcher-walk-top-left-10',
          'watcher-walk-top-left-11',
          'watcher-walk-top-left-12',
          'watcher-walk-top-left-13',
          'watcher-walk-top-left-14',
          'watcher-walk-top-left-15',
          'watcher-walk-top-left-16',
          'watcher-walk-top-left-17',
          'watcher-walk-top-left-18',
          'watcher-walk-top-left-19',
        ],
        'watcher-walk-top': [
          'watcher-walk-top-0',
          'watcher-walk-top-1',
          'watcher-walk-top-2',
          'watcher-walk-top-3',
          'watcher-walk-top-4',
          'watcher-walk-top-5',
          'watcher-walk-top-6',
          'watcher-walk-top-7',
          'watcher-walk-top-8',
          'watcher-walk-top-9',
          'watcher-walk-top-10',
          'watcher-walk-top-11',
          'watcher-walk-top-12',
          'watcher-walk-top-13',
          'watcher-walk-top-14',
          'watcher-walk-top-15',
          'watcher-walk-top-16',
          'watcher-walk-top-17',
          'watcher-walk-top-18',
          'watcher-walk-top-19',
        ],
      },
    },
  },
];
